Bingo.ClientSwitch = {
    apiEndpoint: null,
    savedClientId: null,
    modalLink: null,
};


Bingo.ClientSwitch.init = function (apiEndpoint, redirectLink, modalLink, clientId) {
    Bingo.ClientSwitch.apiEndpoint = apiEndpoint;
    Bingo.ClientSwitch.redirectLink = redirectLink;
    Bingo.ClientSwitch.modalLink = modalLink;

    jQuery('.SwitchClientAlertClose').click(() => {
        window.history.replaceState({}, document.title, window.location.href.replace('do=switchClientAlert-show', ''));
    });
    Bingo.ClientSwitch.savedClientId = clientId;
};

Bingo.ClientSwitch.execute = function () {
    jQuery.ajax({
        url: Bingo.ClientSwitch.apiEndpoint,
        success(data) {
            const currentClient = data.data.value;
            if (!Bingo.ClientSwitch.compareWithSaved(currentClient)) {
                Bingo.ClientSwitch.getHttpStatusPromise(window.location)
                    .done((dataSet, statusText, xhr) => {
                        if (xhr.status === 200) {
                            window.location.replace(Bingo.ClientSwitch.modalLink);
                        } else {
                            window.location.replace(Bingo.ClientSwitch.redirectLink + Bingo.ClientSwitch.modalLink);
                        }
                    })
                    .fail(() => {
                        window.location.replace(Bingo.ClientSwitch.redirectLink + Bingo.ClientSwitch.modalLink);
                    });
            }
        },
    });
};

Bingo.ClientSwitch.compareWithSaved = function (currentClient) {
    return (Bingo.ClientSwitch.savedClientId === currentClient);
};

Bingo.ClientSwitch.getHttpStatusPromise = function (url) {
    return jQuery.ajax({
        type: 'HEAD',
        url,
    });
};
